export default __webpack_public_path__ + "static/media/Recycled_share.5551a988.svg";